import React from 'react';
import { Modal, Typography, Space, Divider } from 'antd';
import { QuestionCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { statusTokens, variantTokens } from '../../../theme/theme';

// Color constants from theme
const COLORS = {
    WARNING: statusTokens.warning,
    INFO: variantTokens.primary,
};

const { Title, Text, Paragraph } = Typography;

/**
 * Modal component for confirming asset order quote request
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onCancel - Function called when cancelling
 * @param {Function} props.onConfirm - Function called when confirming
 * @param {number} props.selectedCount - Number of selected items
 * @param {boolean} props.loading - Whether the confirmation is in progress
 */
const ConfirmOrderModal = ({
    visible,
    onCancel,
    onConfirm,
    selectedCount = 0,
    loading = false
}) => {
    return (
        <Modal
            title={
                <Space>
                    <QuestionCircleOutlined style={{ color: COLORS.WARNING }} />
                    <span>Confirm Quote Request</span>
                </Space>
            }
            open={visible}
            onCancel={onCancel}
            onOk={onConfirm}
            okText="Request Quote"
            cancelText="Cancel"
            confirmLoading={loading}
            okButtonProps={{
                icon: <ShoppingCartOutlined />,
                type: 'primary'
            }}
            width={500}
            centered
        >
            <div style={{ padding: '1rem 0' }}>
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div>
                        <Title level={4} style={{ margin: 0 }}>
                            Ready to request quote?
                        </Title>
                        <Paragraph type="secondary" style={{ margin: '0.5rem 0 0 0' }}>
                            You are about to request a quote for the selected items.
                        </Paragraph>
                    </div>

                    <Divider />

                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: COLORS.INFO }}>
                            {selectedCount}
                        </div>
                        <Text type="secondary">
                            {selectedCount === 1 ? 'item selected' : 'items selected'}
                        </Text>
                    </div>

                    <Divider />

                    <div>
                        <Paragraph>
                            <strong>What happens next:</strong>
                        </Paragraph>
                        <ul style={{ paddingLeft: '1.5rem', margin: 0 }}>
                            <li>Your quote request will be submitted</li>
                            <li>Our team will review your selected items</li>
                            <li>You'll receive a detailed quote within 24-48 hours</li>
                            <li>You can track the status in your orders list</li>
                        </ul>
                    </div>
                </Space>
            </div>
        </Modal>
    );
};

export default ConfirmOrderModal; 